<template>
  <el-dialog
      :title="'Kiểm tra nhận diện AI : ' + name"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      custom-class="sk-dialog"
      top="5vh"
  >
    <div class="sk-dialog-content">
      <!-- Thêm Panel Header đồng bộ với style hệ thống -->
      <div class="sk-panel" style="margin-bottom: 20px;">
        <div class="sk-panel-head">
          <div class="sk-panel-icon"><i class="el-icon-cpu"></i></div>
          <div>
            <p class="sk-panel-title">Lịch sử nhận diện từ Camera AI</p>
            <p class="sk-panel-subtitle">
              Chi tiết các lượt quét nhận diện, mốc thời gian và thiết bị ghi nhận của: <strong>{{ name }}</strong>
            </p>
          </div>
        </div>
      </div>

      <!-- Khu vực hiển thị bảng dữ liệu -->
      <div class="table-wrapper">
        <el-table
            ref="multipleTable"
            highlight-current-row
            :empty-text="textTable"
            :data="responseList"
            :cell-style="tableRowStyle"
            :header-cell-style="tableHeaderColor"
            :max-height="$tableMaxHeight"
            border
            class="sk-table"
        >
          <el-table-column
              type="index"
              label="STT"
              width="60"
              align="center"
          ></el-table-column>
          <el-table-column
              prop="name"
              label="Tên"
              min-width="190"
          ></el-table-column>
          <el-table-column
              prop="employeeNo"
              label="Mã"
              min-width="100"
              align="center"
          ></el-table-column>
          <el-table-column
              prop="nameEvent"
              label="Sử dụng"
              min-width="120"
              align="center"
          ></el-table-column>
          <el-table-column
              prop="time"
              label="Thời gian"
              min-width="120"
              align="center"
          ></el-table-column>
          <el-table-column
              prop="nameDevice"
              label="Thiết bị"
              min-width="300"
          ></el-table-column>
        </el-table>
      </div>
    </div>

    <!-- Footer đồng bộ style nút đóng -->
    <span slot="footer" class="sk-dialog-footer">
      <el-button
          class="btn-cancel"
          type="danger"
          size="medium"
          @click="closeDialog()"
      >
        <i class="el-icon-circle-close"/>
        <span>Đóng</span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import IdentifyAIService from "@/services/IdentifyAIService";

export default {
  props: {
    dialogVisible: null,
  },
  name: "CheckInformationAIDialog",
  data() {
    return {
      textTable: this.$tableLoading,
      responseList: [],
      name: ""
    };
  },
  methods: {
    // Giữ nguyên logic màu của bạn nhưng chỉnh mã màu nhẹ nhàng, hiện đại hơn phù hợp gradient mới
    tableHeaderColor() {
      return "background-color: #6a96d6; color: #fff; font-weight: 600; text-align: center;";
    },
    tableRowStyle({row}) {
      if (row.category === "out") {
        return "color: #3b82f6; font-weight: 500;";
      }
    },
    closeDialog() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.responseList = [];
      }, 300);
    },
    getAddDataInitial(id, date, name) {
      this.name = name;
      IdentifyAIService.checkInformationRecognition(id, date)
          .then((resp) => {
            this.responseList = resp.data.data;
            if (this.responseList.length === 0) {
              this.textTable = this.$tableEmpty;
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
  },
};
</script>

<style lang="scss" scoped>
/* Import file giao diện chuẩn của hệ thống */
@import "@/assets/style/sk-dialog.scss";

/* Đồng bộ Header Dialog giống AttendanceOptionsExportExcel */
/deep/ .sk-dialog {
  border-radius: 12px;
  overflow: hidden;

  .el-dialog__header {
    background: linear-gradient(135deg, #3b82f6, #1d4ed8);
    padding: 20px;
  }

  .el-dialog__title {
    color: #fff;
    font-size: 18px;
    font-weight: 600;
  }
}

/* Đồng bộ nút x (Close) trên header */
::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white !important;
  font-size: 24px;
}

/* Bọc khu vực content */
.sk-dialog-content {
  padding: 10px 5px;
}

/* Bo tròn và căn chỉnh lại bảng để khớp tổng thể style mượt mà */
.table-wrapper {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e5e7eb;

  /deep/ .el-table {
    border: none;

    th.el-table__cell {
      border-bottom: 1px solid #e5e7eb;
    }

    td.el-table__cell {
      padding: 10px 0;
    }
  }
}

/* Đồng bộ chân footer */
.sk-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>